import React from "react";
import Home from "./layouts/Home";
import Enabler from "./layouts/Enabler";
import About from "./layouts/About";
import Footer from "./layouts/Footer";
import Register from "./layouts/Register";
import AboutComponent from "./components/AboutComponent";

function App() {
  return (
    <div className="App">
      <video autoPlay muted loop playsInline id="myVideo">
        <source src={window.innerWidth <= 760 ? "https://human-website.b-cdn.net/pexels-rostislav-uzunov-9150545-1920x1080-24fps.mp4" : "https://human-website.b-cdn.net/pexels-nikita-ryumshin-7832341-1080x1920-25fps%20(1).mp4"} />
      </video>
      <div className="app-container">
        <Home />
        <About />
        <Enabler />
        <Register />
        <Footer />
      </div>
    </div>
  );
}

export default App;
